// extracted by mini-css-extract-plugin
export default {"small":"0","medium":"769px","large":"1025px","xlarge":"1441px","xxlarge":"1920px"};